// PRODUCTION — unsaved-changes guard modal wired to flow editor context
import React from 'react'
import { UnsavedChangesModal } from 'src/components/flow-editor/FlowModals'
import { useFlowEditorContext } from 'src/pages/admin/flow-editor/context/useFlowEditorContext'

export function FlowEditorUnsavedModal() {
  const { cancelLeave, confirmLeave, showUnsavedModal } = useFlowEditorContext()

  return <UnsavedChangesModal open={showUnsavedModal} onLeave={confirmLeave} onStay={cancelLeave} />
}
